/**
 * StyleSheet platform shim — web / desktop / vscode / chrome hosts.
 *
 * On these hosts mini-app-sdk is imported by Vite, which doesn't have react-native.
 * `useDeclarativeStyles` is dead code in web mini-app bundles (they use CSS, not RN
 * stylesheets), so a no-op shim is sufficient.  Metro (mobile host) picks up
 * platform.native.ts instead.
 */

export const StyleSheet = {
  create: <T>(styles: T): T => styles,
  hairlineWidth: 1,
  absoluteFill: Object.freeze({ position: 'absolute' as const, left: 0, right: 0, top: 0, bottom: 0 }),
  absoluteFillObject: Object.freeze({ position: 'absolute' as const, left: 0, right: 0, top: 0, bottom: 0 }),
  flatten: (style: unknown) => style,
};
